<loading [visible]="loading() || saving()"></loading>

@if(!loading()) {
<app-custom-modal [customTitle]="(id ? 'Editar' : 'Nueva') + ' compañía'" (closeFunction)="closeFormFunction()"
    (acceptFunction)="acceptFormFunction()">

    <form [formGroup]="saveForm" (ngSubmit)="saveEntity()" class="space-y-6">

        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <custom-input [autofocus]="true" label="Nombre de la empresa" placeholder="Nombre oficial" type="text"
                [formControlItem]="saveForm.get('name')"></custom-input>

            <custom-input label="CIF" placeholder="A12345678" type="text"
                [formControlItem]="saveForm.get('cif')"></custom-input>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <custom-input label="Email de contacto" placeholder="ejemplo@empresa.com" type="email"
                [formControlItem]="saveForm.get('email')"></custom-input>

            <custom-input label="Código interno" placeholder="ERP-001" type="text"
                [formControlItem]="saveForm.get('code')"></custom-input>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <custom-select label="Tipo de negocio" [formControlItem]="saveForm.controls['business_type']"
                [options]="businessTypes" bindValue="id" bindLabel="name" [isMultiple]="false"
                placeholder="Selecciona un tipo de negocio">
            </custom-select>
        </div>

        @if(isSuperAdmin) {
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <custom-input label="Máximo de usuarios" placeholder="Ej: 10" type="number"
                [formControlItem]="saveForm.get('max_users')"></custom-input>
        </div>
        }

        <div class="mb-4">
            <button type="button"
                class="cursor-pointer px-4 py-2 bg-purple-200 text-purple-900 rounded-lg hover:bg-purple-300 transition text-sm font-medium"
                (click)="toggleOptionalFields()">
                {{ showOptionalFields ? 'Ocultar datos adicionales' : 'Mostrar datos de dirección y pago' }}
            </button>
        </div>

        @if(showOptionalFields) {
        <div class="p-4 mb-4 rounded-xl border-2 border-dashed border-purple-300 bg-purple-50 flex flex-col gap-4">
            <div class="text-purple-700 font-semibold text-sm">Ubicación y Facturación</div>

            <custom-input label="Dirección" placeholder="Calle, número, piso..." type="text"
                [formControlItem]="saveForm.get('address')"></custom-input>

            <div class="grid grid-cols-1 md:grid-cols-3 gap-3">
                <custom-input label="Ciudad" placeholder="Ej: Madrid" type="text"
                    [formControlItem]="saveForm.get('city')"></custom-input>

                <custom-input label="Provincia" placeholder="Ej: Barcelona" type="text"
                    [formControlItem]="saveForm.get('province')"></custom-input>

                <custom-input label="Código Postal" placeholder="6 dígitos" type="text"
                    [formControlItem]="saveForm.get('postal_code')"></custom-input>
            </div>

            <div class="grid grid-cols-1 gap-4 mt-2">
                <custom-input label="Serie Facturas" placeholder="ABC" type="text"
                    [formControlItem]="saveForm.get('invoices_prefix')"></custom-input>
            </div>
        </div>
        }

        <div>
            <label class="flex items-center gap-3 cursor-pointer">
                <input type="checkbox" formControlName="is_active"
                    class="w-5 h-5 text-purple-600 bg-white border-purple-200 rounded focus:ring-purple-500 focus:ring-2 transition-all duration-200">
                <div class="flex items-center gap-2">
                    <span class="text-sm font-medium text-neutral-700">Empresa activa</span>
                    <span class="text-xs text-neutral-500">
                        Define si la empresa puede operar en el sistema
                    </span>
                </div>
            </label>
        </div>

    </form>
</app-custom-modal>
}